import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourseById } from '../../../../../reduxToolkit/Course/coursesSpecSlice';


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card.js";

import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import { Link } from 'react-router-dom';

import navBarStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";

import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

import { Breadcrumb } from 'antd';
import { fetchLearningResources } from "reduxToolkit/features/LearningResource/LearningResourceSlice";

import DropDownButtonLearningResource from "../../../../Components/DropDownButtonLearningResource";


import { notification } from "antd";
import { useTranslation } from 'react-i18next';
import ErrorModal from "../../../../Components/ErrorModal";


const useNavBarStyles = makeStyles(navBarStyles);
const useStyles = makeStyles(styles);

const tailLayout = {
    wrapperCol: {
        offset: 16,
        span: 16,
    },
};
export default function LearningResourceList({ match }) {
    const { t } = useTranslation();
    const classes = useStyles();

    const { id } = match.params
    const dispatch = useDispatch()



    const [openErrorModal, setOpenErrorModal] = React.useState(false);
    const [handledError, setHandledError] = React.useState("");
    const [disabledStatus, setDisabledStatus] = useState(false);
    const handleOpenErrorModal = () => {
        setOpenErrorModal(true);
    };
    const handleCloseErrorModal = () => {
        setOpenErrorModal(false);
    };
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const openNotificationWithIcon = (type, msg) => {
        notification[type]({
            message: type,
            description: msg,
            top: 50,
            duration: 2,
        });
    };
    const fetchAllfetchLearningResources = async () => {
        try {
            const resultAction = await dispatch(fetchLearningResources(id)).unwrap();
            dispatch(fetchCourseById(id));
        } catch (err) {
            setHandledError(err);
            handleOpenErrorModal();
        }
    };
    useEffect(() => {
        fetchAllfetchLearningResources();
        if (localStorage.getItem("CourseState") != "Draft") {
            setDisabledStatus(true);
        }
    }, [dispatch])

    const course = useSelector((state) => state.CourseSpec.courseSpecification)
    const LearningResources = useSelector((state) => state.LearningResource.LearningResources)

    console.log('LearningResources', LearningResources)
    return (
        <div>
            <GridItem>
                <Breadcrumb separator=">">

                    

                    <Breadcrumb.Item>
                        <Link to={`/citrine/CourseSpecificationList/`}>{t('Courses List')}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={`/citrine/courseSpecDetails/${course && course.id && course.id}`}>{course && course.title && course.title}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={`/citrine/specification/course/${id}/LearningResources`} style={{ color: "orange" }} > {t('Learning Resource List')}
                        </Link>
                    </Breadcrumb.Item>

                </Breadcrumb>
            </GridItem>
            <GridContainer >
                <GridItem>

                    {disabledStatus ? <p></p> :
                        <Link to={`/citrine/specification/course/${id}/LearningResources/create`}>
                            <Button color="info"
                                className={classes.updateProfileButton}
                            >
                                {t('Add')}
                            </Button>
                        </Link>
                    }
                </GridItem>
            </GridContainer>

            <GridContainer>
                {LearningResources && LearningResources.map(Element => (
                    <GridItem key={Element.id} xs={12} sm={12} md={6} >
                        <Card style={{ height: 180 }}>
                            <CardBody >
                                <GridContainer xs={12} sm={12} md={12}>
                                    <GridItem xs={12} sm={12} md={11}>
                                        <h4 className={classes.cardProductTitle} style={{ color: "orange" }} >
                                            <a href="#pablo" onClick={e => e.preventDefault()} style={{ color: "orange" }} >
                                                {t('Resource Type')} : {Element && Element.resource_type_details && Element.resource_type_details[0] && Element.resource_type_details[0].name}
                                            </a>

                                        </h4>
                                        <h4 className={classes.cardProductTitle}  >

                                            <a href="#pablo" onClick={e => e.preventDefault()} >
                                                {t('Resources')} : {Element.resource}
                                            </a>

                                        </h4>

                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={1} style={{ zIndex: 1 }} >
                                        {disabledStatus ? <p></p> :
                                            <DropDownButtonLearningResource LearningResource_ID={Element.id} courseID={course && course.id} />
                                        }
                                    </GridItem>
                                </GridContainer>



                            </CardBody>
                        </Card>
                    </GridItem>
                ))}
            </GridContainer>
            <ErrorModal
                open={openErrorModal}
                handleClose={handleCloseErrorModal}
                handledError={handledError}
            />
            {/* 
            <GridContainer>
                <GridItem>
                    <Link to={`/citrine/courses/`}>
                        <Button color="info"
                            className={classes.updateProfileButton}
                        >
                            Exit
                        </Button>
                    </Link>
                </GridItem>
            </GridContainer> */}
        </div >

    );

}




